import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "../HomePage/HomePage";
import AboutPage from "../AboutPage/AboutPage";
import ShopPage from "../ShopPage";
import ProductSinglePage from "../ProductSinglePage";
import CartPage from "../CartPage";
import WishListPage from "../WishListPage";
import CheckoutPage from "../CheckoutPage";
import OrderConfirm from "../OrderConfirm";
import ComparePage from "../ComparePage";
import ErrorPage from "../ErrorPage/ErrorPage";
import LoginPage from "../LoginPage";
import ForgotPassword from "../ForgotPassword";
import RegisterPage from "../Register";
import YourOrdersPage from "../YourOrdersPage";
import ProtectedRoute from "./ProtectedRoute";
import OrderFailed from "../OrderFailed";
import ContactForm from "../../components/ContactFrom/ContactForm";
import PrivacyForm from "../../components/Privacy/Privacy";
import RefundReturnForm from "../../components/RefundReturn/RefundReturn";
import TermsandCondition from "../../components/Terms&Conditions/TermsandCondition";
import Usage from "../../components/Usage/Usage";
import SuccessOrder from "../../components/SuccessOrder";
import SuccessOrderAPS from "../../components/SuccessOrderAPS";
import WholesaleElectronics from "../WholesaleElectronics/WholesaleElectronics";
import WhyChooseUs from "../WhyChooseUs/WhyChooseUs";
import CorporateOrders from "../CorporateOrders/CorporateOrders";
import SupplierStandards from "../SupplierStandards/SupplierStandards";
import Concierge from "../Concierge/Concierge";
import HowToRedeem from "../HowToRedeem/HowToRedeem";


const AllRoute = () => {
  return (
    <div className="App">
      {/* <BrowserRouter> */}
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="home" element={<Homepage />} />
        <Route path="contact" element={<ContactForm />} />
        <Route path="support" element={<ContactForm />} />
        <Route path="privacy" element={<PrivacyForm />} />
        <Route path="rr" element={<RefundReturnForm />} />
        <Route path="tos" element={<TermsandCondition />} />
        <Route path="shipping" element={<Usage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="why-choose-us" element={<WhyChooseUs />} />
        <Route path="corporate" element={<CorporateOrders />} />
        <Route path="corporate-orders" element={<CorporateOrders />} />
        <Route path="supplier-standards" element={<SupplierStandards />} />
        <Route path="concierge" element={<Concierge />} />
        <Route path="redeem" element={<Concierge />} />
        <Route path="how-to-redeem" element={<HowToRedeem />} />
        <Route path="shop" element={<ShopPage />} />
        <Route path="product-single/:slug" element={<ProductSinglePage />} />
        <Route path="cart" element={<CartPage />} />
        <Route
          path="your-orders"
          element={
            <ProtectedRoute>
              <YourOrdersPage />
            </ProtectedRoute>
          }
        />
        <Route path="wishlist" element={<WishListPage />} />
        <Route path="*" element={<ErrorPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="forgot" element={<ForgotPassword />} />{" "}
        <Route
          path="checkout"
          element={
            <ProtectedRoute>
              <CheckoutPage />
            </ProtectedRoute>
          }
        />
        <Route path="success/:orderId" element={<OrderConfirm />} />
        <Route path="failed" element={<OrderFailed />} />
        <Route path="success-order" element={<SuccessOrder />} />
        <Route path="success-order-aps" element={<SuccessOrderAPS />} />
        <Route path="failed-order" element={<OrderFailed />} />
        {/* <Route path="/wholesale-electronics" element={<WholesaleElectronics />} /> */}
        {/* <Route path="compare" element={<ComparePage />} />
        <Route path="contact" element={<ContactPage />} />*/}
      </Routes>
      {/* </BrowserRouter> */}
    </div>
  );
};

export default AllRoute;
